import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { List, Map, fromJS } from 'immutable';

import * as declareActions from 'modules/declare';
import * as currentStatusActions from 'modules/currentStatus';

import { getFormValues, isValid, reset } from 'redux-form';
import { DeclareHeader } from 'components';

class CtDeclareHeader extends Component {
  constructor(props) {
    super(props);

    this.onToggleModal = this.onToggleModal.bind(this);
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 모달 처리
  onToggleModal = viewType => {
    const { ReduxFormReset } = this.props;
    if (viewType === 'targetAdd') {
      ReduxFormReset('formTargetAdd');
    } else if (viewType === 'targetAddExcel') {
      this.setState({ uploadResult: { isUpload: 0, message: '' } });
    }

    this.onTargetExcelReset();

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // // 직급 필터
  // onFilterPosition = data => {
  //   const { tempFilter } = this.state;
  //   const filter = Object.assign({}, tempFilter);

  //   if (typeof examNoArray === 'undefined') {
  //     examNoArray = [data.value];
  //   } else {
  //     const indexArray = examNoArray.findIndex(filterItem => filterItem === data.value);
  //     if (indexArray === -1) {
  //       examNoArray.push(data.value);
  //     } else {
  //       // examNoArray.splice(indexArray, 1);
  //       // // 필터 array가 없다면 삭제
  //       // examNoArray.length === 0 && delete examNoArray;
  //     }
  //   }

  //   this.setState({
  //     tempFilter: filter,
  //     filterUpdate: false
  //   });
  // };

  // 대상자 선택
  // handleSelectDeclare = declareTargetNo => {
  //   const { CurrentStatusActions } = this.props;
  //   CurrentStatusActions.selectDeclareTargetNo({ declareTargetNo });
  // };

  // 검색 타입 선택
  handleSelectOptions = (e, { value }) => {
    const { DeclareActions } = this.props;

    DeclareActions.changeDeclare({
      name: 'examNoArray',
      value: List([value])
    });
  };

  render() {
    const { isModal, selectedTag, selectTarget, totalDeclareCount, tagDataByTagNo, DeclareActions } = this.props;

    return (
      <DeclareHeader
        isModal={isModal}
        selectedTag={selectedTag}
        selectTarget={selectTarget}
        totalDeclareCount={totalDeclareCount}
        tagDataByTagNo={tagDataByTagNo}
        // handleSelectOptions={this.handleSelectOptions}
        declareActions={DeclareActions}
      />
    );
  }
}

const mapStateToProps = state => ({
  isModal: state.currentStatus.get('isModal'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  selectTarget: state.currentStatus.getIn(['target', 'selectTarget']),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  // totalDeclareCount: state.target.get('totalTarget'),
  totalDeclareCount: state.declare.get('totalDeclare'),
  examNoArray: state.declare.get('examNoArray')
});

const mapDispatchToProps = dispatch => ({
  DeclareActions: bindActionCreators(declareActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtDeclareHeader));



// WEBPACK FOOTER //
// ./src/script/containers/declare/CtDeclareHeader.js